
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mavzuli-test",
      function () {
        return require("private-next-pages/mavzuli-test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mavzuli-test"])
      });
    }
  